import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { map, Observable, startWith, tap } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { JsonPipe } from '@angular/common';
@Component({
  selector: 'lib-web-shared-ui-lib-gallery-select-brand-model',
  imports: [
    AsyncPipe,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    JsonPipe,
  ],
  templateUrl: './lib-gallery-select-brand-model.component.html',
  styleUrl: './lib-gallery-select-brand-model.component.scss',
})
export class LibGallerySelectBrandModelComponent implements OnInit, AfterViewInit {
  // @ViewChild('input') input: ElementRef<HTMLInputElement>;
  @ViewChild('input', { static: true }) input!: ElementRef<HTMLInputElement>;
  @ViewChild('inputModel', { static: true }) inputModel!: ElementRef<HTMLInputElement>;
  @ViewChild('inputTireModel', { static: true }) inputTireModel!: ElementRef<HTMLInputElement>;
  @ViewChild('inputTireBrand', { static: true }) inputTireBrand!: ElementRef<HTMLInputElement>;
  // Separate form controls for each autocomplete
  carBrandControl = new FormControl('');
  carModelControl = new FormControl('');
  tireModelControl = new FormControl('');
  tireBrandControl = new FormControl('');

  @Input() set carOptionList(value: any) {
    console.log('carOptionList in select model comp :', value);
    this.carOptionListSignal.set(value);
  }
  @Input() set modelOptionList(value: any) {
    console.log('value in select model comp :', value);
    this.modelOptionListSignal.set(value);

    this.filterTireModel();
  }
  @Input() set tireBrandOptionList(value: any) {
    console.log('tireBrandOptionList in select model comp :', value);
    this.tireBrandOptionListSignal.set(value);
  }

  @Output() emitSelectCarOptionChange = new EventEmitter<any>();
  @Output() emitSelectModelOptionChange = new EventEmitter<any>();

  @Output() emitSelectTireBrandOptionChange = new EventEmitter<any>();

  carOptionListSignal = signal<any>(undefined);
  modelOptionListSignal = signal<any>(undefined);
  carOptionSelectedSignal = signal<any>(undefined);

  tireBrandOptionListSignal = signal<any>(undefined);

  onSelectCarOptionChange(event: MatAutocompleteSelectedEvent) {
    console.log('Selected value:', event.option.value);
    const selectedCar = this.carOptionListSignal().find((car: any) => car.name === event.option.value);
    console.log('Selected Car Object:', selectedCar);

    this.carOptionSelectedSignal.update((options) => {
      //NOTE - update id or name ?
      return { ...options, car_id: selectedCar?.id };
    });
    this.carModelControl.enable();
    // Clear dependent fields when car brand changes
    // this.carModelControl.setValue('');
    // this.tireModelControl.setValue('');
    console.log('this.carOptionSelectedSignal', this.carOptionSelectedSignal());

    this.emitSelectCarOptionChange.emit({ car_id: selectedCar?.id, carObject: this.carOptionSelectedSignal() });
  }

  onSelectModelOptionChange(type: 'car_id' | 'car_model_id' | 'tire_model_name', event: MatAutocompleteSelectedEvent) {
    console.log('car_id', type);
    console.log('car_model_id', type);
    console.log('tire_model_name', type);
    console.log('Selected Model ID:', event.option.value);

    let selectedModel = null;

    if (type === 'car_model_id') {
      selectedModel = this.modelOptionListSignal()?.carModelOptions?.rows.find(
        (model: any) => model.name === event.option.value
      ).id;
      console.log('Selected Model Object:', selectedModel);
    } else if (type === 'car_id') {
      selectedModel = this.carOptionListSignal().find((car: any) => car.name === event.option.value);
      // selectedModel = this.carOptionListSignal()?.
      console.log('Selected Car Object:', selectedModel);
    } else {
      selectedModel = event.option.value;
      console.log('Selected Tire Model Object:', selectedModel);
    }
    this.carOptionSelectedSignal.update((options) => {
      return { ...options, [type]: selectedModel };
    });
    console.log('carOptionSelectedSignal after update:', this.carOptionSelectedSignal());

    this.emitSelectModelOptionChange.emit(this.carOptionSelectedSignal());
  }
  // onSelectCarOptionChange(event: MatSelectChange) {
  //   console.log('Selected value:', event.value);
  //   this.carOptionSelectedSignal.update((options) => {
  //     return { ...options, car_id: event.value };
  //   });
  //   this.emitSelectCarOptionChange.emit(event.value);
  // }

  // onSelectModelOptionChange(type: 'car_model_id' | 'tire_model_name', event: MatSelectChange) {
  //   console.log('Selected Model ID:', event.value);
  //   this.carOptionSelectedSignal.update((options) => {
  //     return { ...options, [type]: event.value };
  //   });
  //   console.log('carOptionSelectedSignal after update:', this.carOptionSelectedSignal());

  //   this.emitSelectModelOptionChange.emit(this.carOptionSelectedSignal());
  // }
  onSelectTireBrandOptionChange(event: MatAutocompleteSelectedEvent) {
    console.log('Selected Tire Brand value:', event.option.value);
    const selectedTireBrand = this.tireBrandOptionListSignal().find((brand: any) => brand.name === event.option.value);
    console.log('Selected Tire Brand Object:', selectedTireBrand);

    this.carOptionSelectedSignal.update((options) => {
      //NOTE - update id or name ?
      return { ...options, tire_brand_id: selectedTireBrand?.id };
    });
    this.tireModelControl.enable();
    console.log('this.carOptionSelectedSignal', this.carOptionSelectedSignal());

    this.emitSelectTireBrandOptionChange.emit(this.carOptionSelectedSignal());
  }
  filteredOptions = signal<any>([]);
  filteredOptionsModel = signal<any>([]);
  filteredOptionsTire = signal<any>([]);
  filteredOptionsTireBrand = signal<any>([]);

  filter(): void {
    const filterValue = this.input.nativeElement.value.toLowerCase();
    this.filteredOptions.set(this.carOptionListSignal().filter((o: any) => o.name.toLowerCase().includes(filterValue)));
  }

  filterModel(): void {
    console.log('filterModel called');

    const filterValue = this.inputModel.nativeElement.value.toLowerCase();
    this.filteredOptionsModel.set(
      this.modelOptionListSignal()?.carModelOptions?.rows.filter((o: any) => o.name.toLowerCase().includes(filterValue))
    );
  }

  filterTireModel(): void {
    const filterValue = this.inputTireModel.nativeElement.value.toLowerCase();
    // if (filterValue !== '') {
    this.filteredOptionsTire.set(
      this.modelOptionListSignal()?.tireModelOptions?.rows.filter((o: any) =>
        o.name.toLowerCase().includes(filterValue)
      )
    );
    console.log('filteredOptionsTire after set:', this.filteredOptionsTire());
    // }
  }

  filterTireBrand(): void {
    const filterValue = this.inputTireBrand.nativeElement.value.toLowerCase();
    // if (this.tireBrandOptionListSignal()) {
    this.filteredOptionsTireBrand.set(
      this.tireBrandOptionListSignal()?.filter((o: any) => o.name.toLowerCase().includes(filterValue))
    );
    // }
  }
  // updateGalleryListSignal(item: IAllData) {
  ngOnInit() {
    this.carModelControl.disable();
    this.tireModelControl.disable();
    console.log('ngOnInit in lib-gallery-select-model comp');

    // Subscribe to car brand control changes to clear dependent fields
    this.carBrandControl.valueChanges.subscribe((value) => {
      if (!value) {
        // Clear car model and tire model when car brand is cleared
        this.carModelControl.setValue('');
        this.tireModelControl.setValue('');
      }
    });

    // Subscribe to car model control changes to clear tire model
    this.carModelControl.valueChanges.subscribe((value) => {
      if (!value) {
        // Clear tire model when car model is cleared
        this.tireModelControl.setValue('');
      }
    });
  }

  ngAfterViewInit() {
    this.filteredOptions.set(this.carOptionListSignal()?.slice());
    this.filteredOptionsModel.set(this.modelOptionListSignal()?.carModelOptions?.rows.slice() || []);

    // this.carBrandControl.valueChanges.pipe(
    //   startWith(''),
    //   tap((value: any | string | null) => {
    //     console.log('value Up log=>', value);
    //     this.filteredOptions.set(this.carOptionListSignal().slice());
    //   })
    // ).subscribe();
  }

  // this.filteredOptionsDown = this.myControlTireDown.valueChanges.pipe(
  //   startWith(''),
  //   map((value: TireSizeDown | string | null) => {
  //     this.loggingService.log('value Down=>', typeof value);
  //     const down_size = typeof value === 'string' ? value : value?.down_size;
  //     this.loggingService.log('down_size =>', down_size);
  //     this.loggingService.log('myControlTireDown =>', this.myControlTireDown);

  //     return down_size ? this._filterDown(down_size as string) : this.filteredOptionsTireDown().slice();
  //   })
  // );

  // Clear all autocomplete values
  clearAllValues(): void {
    //NOTE - set null because if '' value in select will not clear the display value
    this.carBrandControl.setValue(null);
    this.carModelControl.setValue(null);
    this.tireModelControl.setValue(null);
    this.tireBrandControl.setValue(null);
    this.carModelControl.disable();
    this.tireModelControl.disable();

    // Reset the signals as well
    this.carOptionSelectedSignal.set(undefined);

    // Emit a clear event to parent component
    this.emitSelectModelOptionChange.emit(null);

    console.log('All autocomplete values cleared');
  }

  // Clear individual field
  clearCarBrand(): void {
    this.carBrandControl.setValue('');
    console.log('Car brand cleared');
  }

  clearCarModel(): void {
    this.carModelControl.setValue('');
    console.log('Car model cleared');
  }

  clearTireModel(): void {
    this.tireModelControl.setValue('');
    console.log('Tire model cleared');
  }
  clearTireBrand(): void {
    this.tireBrandControl.setValue('');
    console.log('Tire brand cleared');
  }

  private _filter(value: string): { id: number; name: string }[] {
    const filterValue = value.toLowerCase();
    const carOptions = this.carOptionListSignal();
    if (!carOptions) return [];

    return carOptions.filter((option: { id: number; name: string }) => option.name.toLowerCase().includes(filterValue));
  }
}
